<template>
	<v-card>
		<v-card-title v-text="dialogTitle"></v-card-title>
		<v-card-text v-text="dialogMessage"> </v-card-text>
	</v-card>
</template>

<script>
export default {
	name: 'TransactionDialog',
	props: {
		transactionStatus: { type: String, required: true },
		collectionId: { type: String, required: true },
	},
	data() {
		return {
			dialogTitle: '',
			dialogMessage: '',
		};
	},
	created() {
		let message = '';
		switch (this.transactionStatus) {
			case 'success':
				message = `su pago N°${this.collectionId} fue aprobado, ya puede usar su cuenta`;
				this.generateTransactionDialogMessage('aprobado', message);
				break;
			case 'failure':
				//if you press 'volver' without starting the payment, instead of pago n°nulll we display a different message
				if (this.collectionId) {
					message = `su pago N°${this.collectionId} fue rechazado, intente nuevamente`;
				} else {
					message = `no completo su pago, intente nuevamente`;
				}
				this.generateTransactionDialogMessage('rechazado', message);
				break;
			case 'pending':
				message = `su pago N°${this.collectionId} se encuentra pendiente, lo notificaremos cuando complete el pago`;
				this.generateTransactionDialogMessage('pendiente', message);
				break;
		}
	},
	methods: {
		generateTransactionDialogMessage(title, message) {
			this.dialogTitle = title;
			this.dialogMessage = message;
		},
	},
};
</script>

<style scoped></style>
